const BILLEASE_FACTORS_URL = 'https://billease.ph/billease_installments.json';
const STORAGE_KEY = 'BILLEASE_INSTALLMENTS';
const STORAGE_TIME_KEY = 'BILLEASE_INSTALLMENTS_UPDATED_AT';
const CACHE_MAX_AGE = 24 * 60 * 60 * 1000;

class BilleaseInstallment extends HTMLElement {
  static factorsPromise;

  connectedCallback() {
    this.amount = this.querySelector('[data-billease-monthly-amount]');
    this.price = Number(this.dataset.priceCents || 0) / 100;
    this.installments = Number(this.dataset.installments || 24);
    this.isEasyPace = this.dataset.easypace !== 'false';
    this.currency = this.dataset.currency || 'PHP';
    this.section = this.closest('.shopify-section, dialog');
    this.handleProductSelect = this.handleProductSelect.bind(this);
    this.section?.addEventListener('shopify:product:select', this.handleProductSelect);
    this.updateAmount();
  }

  disconnectedCallback() {
    this.section?.removeEventListener('shopify:product:select', this.handleProductSelect);
  }

  handleProductSelect(event) {
    event.promise
      ?.then(({ variant }) => {
        const price = Number(variant?.price?.amount);
        if (!Number.isFinite(price)) return;
        this.price = price;
        this.updateAmount();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[billease-installment] Variant update failed.', error);
      });
  }

  async updateAmount() {
    if (!this.amount || !Number.isFinite(this.price) || this.price <= 0) return;

    const factors = await BilleaseInstallment.getFactors();
    const factorGroup = this.isEasyPace ? factors?.annuity_factor : factors?.installment_factor;
    const fallbackFactor = this.installments === 24 ? (this.isEasyPace ? 0.0734 : 0.0779) : 1 / this.installments;
    const factor = Number(factorGroup?.[this.installments]) || fallbackFactor;
    const monthlyAmount = Math.ceil(factor * this.price);

    this.amount.textContent = new Intl.NumberFormat('en-PH', {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(monthlyAmount);
  }

  static getFactors() {
    if (this.factorsPromise) return this.factorsPromise;

    this.factorsPromise = (async () => {
      try {
        const cachedFactors = localStorage.getItem(STORAGE_KEY);
        const cachedAt = Number(localStorage.getItem(STORAGE_TIME_KEY) || 0);
        if (cachedFactors && Date.now() - cachedAt < CACHE_MAX_AGE) return JSON.parse(cachedFactors);

        const response = await fetch(BILLEASE_FACTORS_URL);
        if (!response.ok) throw new Error(`BillEase factor request failed with ${response.status}`);
        const factors = await response.json();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(factors));
        localStorage.setItem(STORAGE_TIME_KEY, String(Date.now()));
        return factors;
      } catch (error) {
        console.warn('[billease-installment] Using the fallback installment factor.', error);
        return null;
      }
    })();

    return this.factorsPromise;
  }
}

if (!customElements.get('billease-installment')) {
  customElements.define('billease-installment', BilleaseInstallment);
}
